import { getTranslate } from 'assets/titles/title-text';

import { ReactComponent as TextBlockIcon } from 'assets/icons/constructor-create-icons/TEXT_BLOCK.svg';
import { ReactComponent as ImageIcon } from 'assets/icons/constructor-create-icons/IMAGE.svg';
import { ReactComponent as LineChartIcon } from 'assets/icons/constructor-create-icons/LINE_CHART.svg';
import { ReactComponent as BarChartIcon } from 'assets/icons/constructor-create-icons/BAR_CHART.svg';
import { ReactComponent as PieChartIcon } from 'assets/icons/constructor-create-icons/PIE_CHART.svg';
import { ReactComponent as TableIcon } from 'assets/icons/constructor-create-icons/TABLE.svg';
import { ReactComponent as VerticalGapIcon } from 'assets/icons/constructor-create-icons/VERTICAL_GAP.svg';
import { ReactComponent as TopicIcon } from 'assets/icons/constructor-create-icons/TOPIC.svg';
import { ReactComponent as PeriodIcon } from 'assets/icons/constructor-create-icons/PERIOD.svg';
import { ReactComponent as DocumentNumfoundIcon } from 'assets/icons/constructor-create-icons/DOCUMENT_NUMFOUND.svg';
import { ReactComponent as FeedIcon } from 'assets/icons/constructor-create-icons/FEED.svg';
import { ReactComponent as LogoIcon } from 'assets/icons/constructor-icons/LOGO.svg';
    
export const getIconByName = (name) => {
    switch(name){
        case 'TEXT':
            return <TextBlockIcon />;
        case 'IMAGE':
            return <ImageIcon />;
        case 'PAGE_BREAK':
            return <VerticalGapIcon />;
        case 'VERTICAL_GAP':
            return <VerticalGapIcon />;
        case 'PIE_CHART':
            return <PieChartIcon />;
        case 'BAR_CHART':
            return <BarChartIcon />;
        case 'LINE_CHART':
            return <LineChartIcon />;
        case 'TABLE':
            return <TableIcon />;
        case 'TOPIC_NAME':
            return <TopicIcon />;
        case 'DATE_RANGE':
            return <PeriodIcon />;
        case 'DOCUMENT_NUMFOUND':
            return <DocumentNumfoundIcon />;
        case 'FEED':
            return <FeedIcon />;
        case 'LOGO':
            return <LogoIcon />
        default:
            return getTranslate(name);
    }
}

    export const getName = (name) => {
        switch(name){
            case 'TEXT':
                return getTranslate('TEXT_BLOCK');
            default:
                return getTranslate(name);
        }
    }